import { type RoomPriceInfoResponse } from "@/shared/server";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const newPriceAtom = atom<RoomPriceInfoResponse | undefined>({
    default: undefined,
    key: ATOM_KEY.RE_NEW_PRICE,
});

export const useNewPriceValue = () => useRecoilValue(newPriceAtom);
export const useSetNewPriceState = () => useSetRecoilState(newPriceAtom);

const priceAtom = atom({
    default: true,
    key: ATOM_KEY.PRICE_SUCCESS,
});

export const usePriceSuccessValue = () => useRecoilValue(priceAtom);
export const useSetPriceSuccessState = () => useSetRecoilState(priceAtom);
